const InvoiceType = Object.freeze({
    NonRecourse: "non_recourse",
    Recourse: "recourse",
    Reverse: "reverse"
});

export default InvoiceType;
